if (!customElements.get("collection-load-more")) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      this.setProperties();

      window.addEventListener("shopify:section:load", () => {
        this.setProperties();
      });

      this.btnLoadMore.addEventListener("click", (e) => {
        e.preventDefault();

        this.btnLoadMore.setAttribute("disabled", true);

        this.loadMoreProducts();
      });
    }

    setProperties() {
      this.productGrid = document.querySelector("#product-grid");
      this.btnLoadMore = this.querySelector(".js-btn-load-more");
      this.isLastPage = this.classList.contains("hidden");
    }

    async loadMoreProducts() {
      try {
        const nextPageResponse = await fetch(
          `${this.btnLoadMore.dataset.href}`
        );
        const nextPageText = await nextPageResponse.text();

        const nextPageHTML = new DOMParser().parseFromString(
          nextPageText,
          "text/html"
        );

        const productGrid = nextPageHTML.querySelector("#product-grid");
        const loadMoreContainer = nextPageHTML.querySelector(
          "collection-load-more"
        );
        const btnLoadMore =
          loadMoreContainer.querySelector(".js-btn-load-more");

        const isLoadMoreHidden = loadMoreContainer.classList.contains("hidden");

        this.productGrid.insertAdjacentHTML("beforeend", productGrid.innerHTML);

        if (isLoadMoreHidden) {
          this.isLastPage = true;
          this.classList.add("hidden");

          return;
        }

        this.btnLoadMore.dataset.href = btnLoadMore.dataset.href;
      } catch (error) {
        console.error(error);

        alert(error.message);
      } finally {
        this.btnLoadMore.removeAttribute("disabled");
      }
    }
  }

  customElements.define("collection-load-more", CollectionLoadMore);
}
